export class ApplyStatus {
  id:number;
  name:string;
  order:number;
  status:number;
  company_id:number;
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/apply-status.ts